import React from "react";
import useRyanairHungaryInfo from "./useRyanairHungaryInfo.js";
export function useCanRenderRyanairHungaryInfoMobile(flight) {
    const data = useRyanairHungaryInfo(flight);
    return !!data?.content;
}
export default function RyanairHungaryInfoMobile(props) {
    const data = useRyanairHungaryInfo(props.flight);
    if (!data?.content)
        return null;
    return React.createElement(React.Fragment, null, data.content);
}
